import { render } from "./feature-attachment.vue?vue&type=template&id=5b3dc33d"
import script from "./feature-attachment.vue?vue&type=script&lang=js"
export * from "./feature-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__